export const GlobalResources = {
    APP_TITLE: 'HEPNOX',
    APP_SUBTITLE: 'Domain'
}